import { useProfileStore } from "@/store/profile-store";
import { useEffect } from "react";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { sendInitData, loadCurrentUser } = useProfileStore();

  useEffect(() => {
    const initData = window?.Eitaa?.WebApp?.initData;
    if (initData) {
      // Inside the Eitaa miniapp: authenticate via the init-data callback.
      sendInitData(initData);
    } else {
      // Plain web: rehydrate a stored OTP session from /auth/me (no-op if there
      // is no token).
      loadCurrentUser();
    }
  }, [sendInitData, loadCurrentUser]);

  return <>{children}</>;
};
